module.exports = __webpack_public_path__ + "static/media/offices (5).1166c610.webp";